import { Component, Input, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { TransactionModel } from "src/app/const/transaction-model.enum";
import { AppService } from "src/app/service/app.service";
import { DataService } from "src/app/service/data.service";
import { FilterComponent, IFilterData } from "../filter/filter.component";

@Component({
  selector: "app-redeemption",
  templateUrl: "./redeemption.component.html",
  styleUrls: ["./redeemption.component.scss"],
})
export class RedeemptionComponent implements OnInit {
  @Input() isShowFilters: boolean;

  limit: number = 20;
  pageNumber: number = 1;
  startDate: any = "";
  endDate: any = "";
  search: any = "";
  redemptionsList: any = [];
  loading: boolean = false;
  filterData: IFilterData;

  constructor(
    private dataService: DataService,
    private appService: AppService,
    private modalCtrl: ModalController
  ) {}

  ngOnInit() {
    this.getRedeemptionList(null);
  }

  getRedeemptionList(event) {
    const params = {
      limit: this.limit,
      pageNumber: this.pageNumber,
      startDate: this.startDate,
      endDate: this.endDate,
      search: this.search,
    };

    if (!params.startDate) delete params.startDate;
    if (!params.endDate) delete params.endDate;

    this.loading = true;
    this.dataService.getRedeemptions(params).subscribe(
      (res: any) => {
        if (event) {
          this.redemptionsList = this.redemptionsList.concat(
            res.data.redemptionsList
          );
          event.target.complete();
          if (res.data.length === 0) {
            this.decrementSkip();
          }
        } else {
          this.redemptionsList = res.data.redemptionsList;
        }
        this.loading = false;
      },
      (err) => {
        this.appService.toastMessage("Failed to fetch redeemption list");
        this.loading = false;
        if (event) {
          event.target.complete();
        }
      }
    );
  }

  loadDataOnScroll(event) {
    this.pageNumber += 1;
    this.getRedeemptionList(event);
  }

  searchRedeemption(ev) {
    this.search = ev.target.value;
    this.getRedeemptionList(null);
  }

  async filter() {
    this.pageNumber = 1;
    const modal = await this.modalCtrl.create({
      component: FilterComponent,
      componentProps: {
        transactionModel: TransactionModel.COUPON,
        filterData: this.filterData,
        isStatusEnabled: false,
      },
    });
    modal.present();
    this.filterData = await (await modal.onWillDismiss()).data;
    this.endDate = this.filterData.endDate;
    this.startDate = this.filterData.fromDate;
    this.getRedeemptionList(null);
  }

  filterActive() {
    if (this.startDate || this.endDate) {
      return true;
    }
    return false;
  }

  async viewRedeemption(redeemption) {
    const modal = await this.modalCtrl.create({
      component: ViewRedeem,
      componentProps: {
        redeemption: redeemption,
      },
    });
    modal.present();
  }

  decrementSkip() {
    if (this.pageNumber > 1) {
      this.pageNumber -= 1;
    }
  }
}

@Component({
  template: `
    <ion-content>
      <div style="text-align: center;padding: 10%;">
        <ion-avatar style="margin: auto;">
          <img src="https://ionicframework.com/docs/img/demos/avatar.svg" />
        </ion-avatar>

        <h2>{{ redeemption?.customerName }}</h2>
        <a href="tel:{{ redeemption?.customerPhone }}">{{
          redeemption?.customerPhone
        }}</a
        ><br />
        <div class="dotted-line"></div>
        <h2 style="color: #6bc048">
        {{"No. of leaflets" | translate}} {{ redeemption?.leafletsCount }}
        </h2>
        <div class="dotted-line"></div>
        <div class="addr">
          <p>{{ redeemption?.date | date: "medium":"+0800" }}</p>
          <p>{{ redeemption?.receiptNumber }}</p>
        </div>
        <!-- <h2 style="color: #6bc048">Successfull</h2> -->
        <!-- <div class="dotted-line"></div> -->
        <!-- <ion-row>
          <ion-col>
            <h3>Product name</h3>
          </ion-col>
          <ion-col>
            <h3>QTY</h3>
          </ion-col>
        </ion-row>
        <div class="dotted-line"></div>
        <div class="addr">
          <span>Deliverd by </span><br />
          <span>Way #: 6565<br />House #: 5656<br />City #: Muscat</span>
        </div> -->
      </div>
    </ion-content>
  `,
  styleUrls: ["./redeemption.component.scss"],
})
export class ViewRedeem {
  @Input() redeemption;
}
